import React from 'react';
import { useTranslation } from 'react-i18next';
import { ClaimListTableRow } from './ClaimListTableRow';
import { userClaimableList } from 'utils/constants/claim.const';

type ClaimListViewProps = {
  claimList: typeof userClaimableList;
};

export function ClaimListView({ claimList }: ClaimListViewProps) {
  const { t } = useTranslation('claim');

  const columns = [
    'ALLOCATION',
    'START_DATE',
    'END_DATE',
    'CLAIMED',
    'CLAIMABLE',
    '',
  ];

  return (
    <div className='mx-auto w-full overflow-x-scroll !font-[Montserrat]'>
      <table className='min-w-full table-auto border-separate border-spacing-x-0 border-spacing-y-3 rounded-xl'>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th
                key={index}
                className='text-nowrap px-4 py-2 text-center text-xs font-normal text-[#C1CAD6]'
              >
                {t(column)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {claimList.map((item, index) => (
            <ClaimListTableRow
              key={item.projectClaimContractAddress + index}
              item={item}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
